// Painel (W0: estado da plataforma + o que cada secção vai trazer).
import { ApiStatus } from "@ecliptica/game-ui";
import { useTranslation } from "@ecliptica/i18n";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, PageHeader } from "@ecliptica/ui";
import { Link } from "react-router";
import { useCan } from "../../features/auth/RequireStaff";
import { SECTIONS } from "../../features/nav/sections";
import { PendingCompensations } from "./PendingCompensations";
import { SupportStats } from "./SupportStats";

export function DashboardPage() {
  const { t } = useTranslation();
  const can = useCan();
  return (
    <>
      <PageHeader title={t("nav.dashboard")} description={t("dashboard.description")} />
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
        <ApiStatus />
        {can("support.read") && <SupportStats />}
        {can("compensations.approve") && <PendingCompensations />}
        {SECTIONS.filter((s) => s.key !== "dashboard" && can(s.permission)).map(({ key, path, icon: Icon, milestone }) => (
          <Link key={key} to={path} className="group">
            <Card className="h-full transition-colors group-hover:border-gold/60">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Icon className="size-5" /> {t(`nav.${key}`)}
                </CardTitle>
                <CardDescription>{t(`sections.${key}`)}</CardDescription>
              </CardHeader>
              {milestone && <CardContent className="text-xs text-muted-foreground">{t("soon.milestone", { milestone })}</CardContent>}
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
}
